import { ROICurvesToolipParams } from '@/dashboards/BudgetOptimization/components/ROICurves/tooltips/renderTooltip';
import { Typography } from '@analytical-alley/ui';
import React from 'react';

export const SelectedTooltip = ({
    params,
    selectedSeriesName,
    contributionFormatter,
    investmentFormatter,
}: {
    params: ROICurvesToolipParams;
    selectedSeriesName?: string;
    contributionFormatter?: (value: string | undefined | number) => string;
    investmentFormatter?: (value: string | undefined | number) => string;
}) => {
    if (!selectedSeriesName) {
        return null;
    }

    const hoveredItem = params.find(
        (param) => param.seriesName === selectedSeriesName,
    );

    if (!hoveredItem) {
        return null;
    }

    return (
        <div className="tooltip-content-md">
            <Typography className="text-dark dark:text-dark">
                {hoveredItem.seriesName}
            </Typography>
            <table className="font-sans">
                <tbody>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Investment:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {investmentFormatter
                                    ? investmentFormatter(
                                          params[0]?.axisValueLabel,
                                      )
                                    : params[0]?.axisValueLabel}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td className="pr-2">
                            <Typography className="text-black dark:text-black">
                                Contribution:
                            </Typography>
                        </td>
                        <td>
                            <Typography className="text-dark dark:text-dark">
                                {contributionFormatter
                                    ? contributionFormatter(hoveredItem.value)
                                    : hoveredItem.value}
                            </Typography>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
